var React = require('react');

function Enter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21.41 10.59-7.99-8c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0l7.99-8c.79-.79.79-2.05 0-2.83zM13.5 14.5V12H10v3H8v-4c0-.55.45-1 1-1h4.5V7.5L17 11l-3.5 3.5z"}));
}

Enter.defaultProps = {"fill":"currentColor","focusable":"false","aria-hidden":"true","viewBox":"0 0 24 24"};

module.exports = Enter;

Enter.default = Enter;
